export var banned_words = [
  'culo',
  'culi',
  'figa',
  'pene',
  'peni',
  'culo',
  'culi',
  'sega',
  'suca',
  'cazzo',
  'troia',
  'troie',
  'merda',
  'merde',
  'fighe',
  'tette',
  'negro',
  'negri',
  'vacca',
  'pirla',
  'cagata',
  'cagate',
  'cagare',
  'cacare',
  'vagina',
  'vacche',
  'frocio',
  'piscia',
  'culona',
  'terone',
  'teroni',
  'fregna',
  'infame',
  'puttana',
  'puttane',
  'stronzo',
  'stronzi',
  'minchia',
  'fanculo',
  'fottere',
  'scopare',
  'terrone',
  'terroni',
  'cornuto',
  'pompino',
  'dio cane',
  'bastardo',
  'bastardi',
  'coglione',
  'coglioni',
  'bordello',
  'bordelli',
  'scoregge',
  'smerdare',
  'trombata',
  'stocazzo',
  'inculato',
  'inculati',
  'inculare',
  'mignotta',
  'pugnetta',
  'mortacci',
  'culatone',
  'dio porco',
  'incazzare',
  'scoreggia',
  'finocchio',
  'ricchione',
  'baldracca',
  'puttanata',
  'vaffanculo',
  'deficiente',
  'deficienti',
  'con',
  'cul',
  'bite',
  'caca',
  'meuf',
  'nana',
  'pédé',
  'pipi',
  'pute',
  'suce',
  'zizi',
  'bitte',
  'chier',
  'clito',
  'conne',
  'idiot',
  'merde',
  'mince',
  'nègre',
  'negro',
  'péter',
  'vache',
  'abruti',
  'baiser',
  'batard',
  'bordel',
  'chatte',
  'chiant',
  'chieur',
  'crétin',
  'debile',
  'dégage',
  'enculé',
  'foutre',
  'fucker',
  'gerber',
  'guenon',
  'gueule',
  'idiote',
  'niquer',
  'ordure',
  'pédale',
  'pisser',
  'pouffe',
  'putain',
  'salaud',
  'salope',
  'téteux',
  'branler',
  'chiante',
  'chiasse',
  'chienne',
  'chieuse',
  'conasse',
  'connard',
  'couille',
  'déconne',
  'enfoiré',
  'merdeux',
  'pétasse',
  'sa race',
  'stupide',
  'suceuse',
  'charogne',
  'chiottes',
  'couilles',
  'couillon',
  'déconner',
  'emmerder',
  'enculeur',
  'imbécile',
  'la vache',
  'merdasse',
  'merdeuse',
  'mon dieu',
  'salopard',
  'branleuse',
  'conneries',
  'emmerdant',
  'emmerdeur',
  'gross cul',
  'sac merde',
  'saloperie',
  'ta gueule',
  'condom',
  'coolie',
  'crappy',
  'crimes',
  'crotch',
  'cummer',
  'cunntt',
  'darkie',
  'diddle',
  'doodoo',
  'escort',
  'faeces',
  'faggot',
  'farted',
  'fatass',
  'fckcum',
  'feltch',
  'fetish',
  'fister',
  'flange',
  'fondle',
  'fucked',
  'fucker',
  'fuckin',
  'fuckit',
  'fuckme',
  'fungus',
  'gaysex',
  'geezer',
  'gringo',
  'gummer',
  'gyppie',
  'hardon',
  'heroin',
  'herpes',
  'hijack',
  'hindoo',
  'hitler',
  'hodgie',
  'honger',
  'honkey',
  'hooker',
  'horney',
  'horny',
  'hummer',
  'iblowu',
  'incest',
  'insest',
  'jizzim',
  'jizzum',
  'kaffer',
  'kaffir',
  'kaffre',
  'kanake',
  'kigger',
  'killed',
  'killer',
  'kondum',
  'krappy',
  'kummer',
  'lesbian',
  'libido',
  'licker',
  'lickme',
  'macaca',
  'mockey',
  'mockie',
  'molest',
  'murder',
  'niggah',
  'niggaz',
  'nigger',
  'niggle',
  'niggor',
  'niggur',
  'niglet',
  'nignog',
  'nipple',
  'nittit',
  'nlgger',
  'nlggor',
  'nookey',
  'nookie',
  'noonan',
  'nooner',
  'nudger',
  'orgasm',
  'orgies',
  'pecker',
  'penile',
  'phuked',
  'pimped',
  'pimper',
  'pissed',
  'pisser',
  'pisses',
  'pissin',
  'pistol',
  'pooper',
  'popimp',
  'pudboy',
  'pussie',
  'racial',
  'racist',
  'rapist',
  'rectum',
  'reefer',
  'reject',
  'retard',
  'ribbed',
  'rigger',
  'rimjob',
  'robber',
  'russki',
  'sexing',
  'sexpot',
  'sextoy',
  'sexual',
  'shited',
  'shitty',
  'skanky',
  'slopey',
  'slutty',
  'snatch',
  'sniper',
  'sodomy',
  'soviet',
  'spooge',
  'spunky',
  'stiffy',
  'stroke',
  'stupid',
  'sucker',
  'suckme',
  'swalow',
  'tantra',
  'terror',
  'tinkle',
  'titjob',
  'tittie',
  'tongue',
  'tortur',
  'tosser',
  'tranny',
  'trojan',
  'turnon',
  'uterus',
  'vagina',
  'virgin',
  'wanker',
  'weapon',
  'weenie',
  'weewee',
  'whites',
  'whitey',
  'wigger',
  'willie',
  'wuzzie',
  'zigabo',
  'Shitbag',
  'Wazzock',
  'Cumwipe',
  'Bellend',
  'Fuckwit',
  'Tosspot',
  'Nutsack',
  'analsex',
  'aroused',
  'assfuck',
  'asshole',
  'asshore',
  'asskiss',
  'asslick',
  'asswipe',
  'badfuck',
  'banging',
  'bastard',
  'bazooms',
  'beatoff',
  'bigbutt',
  'bitcher',
  'bitches',
  'bitchez',
  'bitchin',
  'blowjob',
  'bollick',
  'bollock',
  'bondage',
  'boobies',
  'brothel',
  'buggery',
  'bumfuck',
  'buttman',
  'cocaine',
  'cocknob',
  'coondog',
  'crapola',
  'crapper',
  'cumfest',
  'cumming',
  'cumquat',
  'cumshot',
  'dickman',
  'dickwad',
  'dipshit',
  'drunken',
  'dumbass',
  'ecstacy',
  'execute',
  'fairies',
  'farting',
  'fatfuck',
  'felatio',
  'felcher',
  'fisting',
  'flasher',
  'fuckbag',
  'fuckers',
  'fuckher',
  'fuckina',
  'fucking',
  'fuckoff',
  'fuckpig',
  'fuckyou',
  'funeral',
  'funfuck',
  'gangsta',
  'genital',
  'getiton',
  'goddamn',
  'handjob',
  'hiscock',
  'honkers',
  'hookers',
  'hooters',
  'hosejob',
  'hostage',
  'hotdamn',
  'hustler',
  'illegal',
  'jackass',
  'jackoff',
  'japcrap',
  'jerkoff',
  'jigaboo',
  'jiggabo',
  'jimfish',
  'juggalo',
  'killing',
  'kissass',
  'kumming',
  'kumquat',
  'lactate',
  'lesbain',
  'lesbayn',
  'lesbian',
  'livesex',
  'lovegun',
  'lubejob',
  'mulatto',
  'muncher',
  'nastyho',
  'negroes',
  'negroid',
  'niggard',
  'niggers',
  'niggled',
  'niggles',
  'orgasim',
  'pansies',
  'panties',
  'peehole',
  'penises',
  'phuking',
  'phukked',
  'phungky',
  'pindick',
  'pissing',
  'pissoff',
  'playboy',
  'pooping',
  'puddboy',
  'puntang',
  'pussies',
  'quashie',
  'quickie',
  'raghead',
  'rearend',
  'redneck',
  'reestie',
  'refugee',
  'remains',
  'rimming',
  'russkie',
  'schlong',
  'scrotum',
  'servant',
  'sexfarm',
  'sextogo',
  'sextoys',
  'shaggin',
  'sheeney',
  'shinola',
  'shitcan',
  'shitfit',
  'shiting',
  'shitola',
  'shitted',
  'shitter',
  'skumbag',
  'slapper',
  'snigger',
  'spitter',
  'strapon',
  'suckoff',
  'suicide',
  'swallow',
  'tarbaby',
  'titfuck',
  'titties',
  'torture',
  'trannie',
  'triplex',
  'twinkie',
  'upskirt',
  'urinary',
  'urinate',
  'vaginal',
  'vatican',
  'wanking',
  'waysted',
  'welcher',
  'wetback',
  'wetspot',
  'whacker',
  'whigger',
  'whiskey',
  'Bollocks',
  'Cocknose',
  'Knobhead',
  'Jizzcock',
  'Wankface',
  'Gobshite',
  'abortion',
  'arsehole',
  'assassin',
  'assclown',
  'ass hole',
  'assholes',
  'assklown',
  'asslover',
  'assmunch',
  'asswhore',
  'ballsack',
  'bazongas',
  'bisexual',
  'bitching',
  'blackman',
  'blackout',
  'buggered',
  'bullcrap',
  'bulldike',
  'bulldyke',
  'bullshit',
  'bunghole',
  'buttbang',
  'buttface',
  'buttfuck',
  'butthead',
  'buttplug',
  'clitoris',
  'cockhead',
  'cockknob',
  'cocksman',
  'cocksuck',
  'cocktail',
  'copulate',
  'cornhole',
  'criminal',
  'cumqueen',
  'cunteyed',
  'cuntfuck',
  'cuntlick',
  'cybersex',
  'datnigga',
  'defecate',
  'dickhead',
  'dick',
  'dickless',
  'dicklick',
  'dickweed',
  'dipstick',
  'dripdick',
  'dumbfuck',
  'easyslut',
  'eatballs',
  'eatpussy',
  'erection',
  'executed',
  'fastfuck',
  'felching',
  'fellatio',
  'feltcher',
  'fistfuck',
  'footfuck',
  'footstar',
  'foreskin',
  'foursome',
  'freefuck',
  'fuckable',
  'fuckedup',
  'fuckface',
  'fuckfest',
  'fuckhead',
  'fuckknob',
  'fucktard',
  'fuck you',
  'gangbang',
  'godammit',
  'goddamit',
  'gonzagas',
  'gotohell',
  'headfuck',
  'henhouse',
  'hijacker',
  'homicide',
  'horniest',
  'hotpussy',
  'intheass',
  'jackshit',
  'japanese',
  'jijjiboo',
  'jizjuice',
  'knockers',
  'lapdance',
  'limpdick',
  'lingerie',
  'lovebone',
  'manhater',
  'manpaste',
  'meatrack',
  'molester',
  'molestor',
  'mosshead',
  'muffdive',
  'murderer',
  'narcotic',
  'niggards',
  'niggling',
  'ontherag',
  'peepshow',
  'peepshpw',
  'phonesex',
  'phukking',
  'pimpjuic',
  'pimpsimp',
  'pisshead',
  'piss off',
  'playgirl',
  'poontang',
  'pornking',
  'pussycat',
  'radicals',
  'redlight',
  'retarded',
  'roundeye',
  'screwyou',
  'sexhound',
  'sexhouse',
  'sexslave',
  'sexually',
  'sexwhore',
  'sexymoma',
  'shagging',
  'shitdick',
  'shitface',
  'shitfuck',
  'shitfull',
  'shithead',
  'shitlist',
  'shitting',
  'shooting',
  'showtime',
  'slanteye',
  'slutting',
  'slutwear',
  'sniggers',
  'snowback',
  'sodomise',
  'sodomite',
  'sodomize',
  'spermbag',
  'spigotty',
  'stringer',
  'stroking',
  'suckdick',
  'swastika',
  'syphilis',
  'testicle',
  'thirdeye',
  'thirdleg',
  'threeway',
  'titlover',
  'tuckahoe',
  'uptheass',
  'vibrater',
  'vibrator',
  'vietcong',
  'violence',
  'Bugger me',
  'Bitchtits',
  'Pissflaps',
  'Shitpouch',
  'Jizzstain',
  'Twat face',
  'analannie',
  'assbagger',
  'asscowboy',
  'assfucker',
  'assjockey',
  'asskisser',
  'asslicker',
  'assmonkey',
  'asspacker',
  'asspirate',
  'assranger',
  'bicurious',
  'bisexual',
  'bitchslap',
  'bootycall',
  'bountybar',
  'breastjob',
  'breastman',
  'butchdike',
  'butchdyke',
  'buttbang',
  'buttfuck',
  'buttmunch',
  'buttstain',
  'clamdiver',
  'cockblock',
  'cockfight',
  'cocklover',
  'cockqueen',
  'cockrider',
  'cocksmith',
  'cocksucker',
  'cocktease',
  'communist',
  'crackpipe',
  'criminals',
  'crotchrot',
  'cumbubble',
  'cumjockey',
  'dickbrain',
  'dick head',
  'dragqueen',
  'dragqween',
  'dumbbitch',
  'ejaculate',
  'excrement',
  'execution',
  'explosion',
  'fatfucker',
  'feltching',
  'fornicate',
  'freakfuck',
  'fuckbuddy',
  'fuckfreak',
  'fuckwhore',
  'gatorbait',
  'goddamm',
  'hijacking',
  'hitlerism',
  'hitlerist',
  'horseshit',
  'hottotrot',
  'inthebuff',
  'kumbubble',
  'kumbullbe',
  'loadedgun',
  'marijuana',
  'mastabate',
  'moneyshot',
  'mothafuck',
  'muffdiver',
  'nastyslut',
  'niggarded',
  'niggardly',
  'nigglings',
  'nutfucker',
  'penthouse',
  'picaninny',
  'pimpjuice',
  'pornflick',
  'prickhead',
  'primetime',
  'pubiclice',
  'pussylips',
  'rearentry',
  'rentafuck',
  'scallywag',
  'sexkitten',
  'shiteater',
  'shitfaced',
  'shithouse',
  'shitstain',
  'shortfuck',
  'sixsixsix',
  'sixtynine',
  'skankfuck',
  'skinflute',
  'slaughter',
  'sleezebag',
  'slideitin',
  'slimeball',
  'slopehead',
  'slutwhore',
  'sniggered',
  'splittail',
  'stripclub',
  'suckmyass',
  'suckmytit',
  'swallower',
  'sweetness',
  'terrorist',
  'testicles',
  'thicklips',
  'threesome',
  'titfucker',
  'titfuckin',
  'titlicker',
  'towelhead',
  'trisexual',
  'upthebutt',
  'yellowman',
  'Bugger off'
];